import React from "react";
import uuid from "react-uuid";
import { IReleaseSummary } from "../../utils/fetchers/types";

import styles from './ReleaseSummary.module.css'

type TReleaseSummary = {
  summary: IReleaseSummary,
}

const ReleaseSummary: React.FC<TReleaseSummary> = ({ summary }) => {
  const { title, body, video } = summary;

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.wrapperParagraphs}>
      {
        body.map((text) => (
          <p
            key={uuid()}
            className={styles.paragraph}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ))
      }
      </div>
      {
        video &&
        <p className={styles.videoLine}>
          {video.text ? `${video.text} ` : ''}
          <a
            className={styles.videoLink}
            href={video.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {video.linkText}
          </a>
        </p>
      }
    </div>
  );
};

export default ReleaseSummary;
